import React from 'react';
import { Paper } from '@material-ui/core';

const Surface = ({ children, className, style }) => {
  return (
    <Paper style={{ boxShadow: '0 8px 16px 0 rgb(0 0 0 / 10%)', ...style }} className={className}>
      {children}
    </Paper>
  );
};

export default Surface;
